module.exports = __webpack_public_path__ + "static/media/13.dfb03a31.svg";